import NoSamplesMessage from 'components/Content/FreeSamples/NoSamplesMessage/NoSamplesMessage';

export default NoSamplesMessage;
